export class PortalError extends Error {
  key?: string;

  constructor(name: string, message: string, translationKey?: string) {
    super(message);
    this.name = name;
    this.key = translationKey;
  }
}
